import axios from '../../app/api/axios';
import setAuthToken from './utils/setAuthToken';
import jwt_decode from 'jwt-decode';
import {
    SET_CURRENT_USER,
    SIGNUP_FAILURE,
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_CONFIRM_EMAIL_FAILURE,
    SIGNUP_CONFIRM_EMAIL_REQUEST,
    SIGNUP_CONFIRM_EMAIL_SUCCESS,
    SIGNIN_REQUEST,
    SIGNIN_FAILURE,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    CHECK_FORGOT_PASSWORD_KEY_REQUEST,
    CHECK_FORGOT_PASSWORD_KEY_SUCCESS,
    CHECK_FORGOT_PASSWORD_KEY_FAILURE,
    SET_NEW_PASSWORD_REQUEST,
    SET_NEW_PASSWORD_SUCCESS,
    SET_NEW_PASSWORD_FAILURE,
} from './types';

export const signupUser = (userData, history) => dispatch => {
    dispatch(setSignupRequest());

    axios.post('wp/v2/users/register', userData)
        .then(res =>
            dispatch({
                type: SIGNUP_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUP_FAILURE,
                payload: err.response.data
            })
        );
};

export const signinUser = userData => dispatch => {
    dispatch(setSigninRequest());

    axios.post('wp/v2/users/signin', userData)
        .then(res => {
            const {token} = res.data;

            // Save the token to the local storage
            localStorage.setItem('jwtToken', token);

            // Set the token to the Auth header
            setAuthToken(token);

            // Decode the JWT token to get user data
            const decoded = jwt_decode(token);

            // Set the current user
            dispatch(setCurrentUser(decoded));
        })
        .catch(err =>
            dispatch({
                type: SIGNIN_FAILURE,
                payload: err.response.data
            })
        );
};

export const signoutUser = () => dispatch => {
    // Remove the token from localStorage
    localStorage.removeItem('jwtToken');

    // Remove the Auth header for future requests
    setAuthToken(false);

    // Set current user to {} which will set isAuthenticated to false
    dispatch(setCurrentUser({}));
};

export const signupConfirmEmail = (key, idUser) => dispatch => {
    dispatch(setSignupConfirmEmailRequest());

    axios.post('wp/v2/users/register/confirm_email', {key: key, idUser: idUser})
        .then(res =>
            dispatch({
                type: SIGNUP_CONFIRM_EMAIL_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUP_CONFIRM_EMAIL_FAILURE,
                payload: err.response.data
            })
        );
};

export const requestPasswordResetLink = email => dispatch => {
    dispatch(setForgotPasswordRequest());

    axios.post('wp/v2/users/request_new_password', {email: email})
        .then(res =>
            dispatch({
                type: FORGOT_PASSWORD_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: FORGOT_PASSWORD_FAILURE,
                payload: err.response.data
            })
        );
};

export const checkForgotPasswordKey = (key, idUser) => dispatch => {
    dispatch(setCheckForgotPasswordKeyRequest());

    axios.post('wp/v2/users/check_reset_password_key', {key: key, id: idUser})
        .then(res =>
            dispatch({
                type: CHECK_FORGOT_PASSWORD_KEY_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: CHECK_FORGOT_PASSWORD_KEY_FAILURE,
                payload: err.response.data
            })
        );
};

export const setNewPassword = (key, idUser, password, password_confirmation) => dispatch => {
    dispatch(setNewPasswordRequest());

    axios.post('wp/v2/users/reset_password', {
        key: key,
        id: idUser,
        password: password,
        password_confirmation: password_confirmation
    })
        .then(res =>
            dispatch({
                type: SET_NEW_PASSWORD_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SET_NEW_PASSWORD_FAILURE,
                payload: err.response.data
            })
        );
};

export const setCurrentUser = decoded => {
    return {
        type: SET_CURRENT_USER,
        payload: decoded
    }
};

export const setSignupRequest = () => {
    return {
        type: SIGNUP_REQUEST
    };
};

export const setSigninRequest = () => {
    return {
        type: SIGNIN_REQUEST
    };
};

export const setSignupConfirmEmailRequest = () => {
    return {
        type: SIGNUP_CONFIRM_EMAIL_REQUEST
    };
};

export const setForgotPasswordRequest = () => {
    return {
        type: FORGOT_PASSWORD_REQUEST
    };
};

export const setCheckForgotPasswordKeyRequest = () => {
    return {
        type: CHECK_FORGOT_PASSWORD_KEY_REQUEST
    };
};

export const setNewPasswordRequest = () => {
    return {
        type: SET_NEW_PASSWORD_REQUEST
    };
};



// WEBPACK FOOTER //
// ./src/features/Auth/actions.js